/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2023 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import { RouteConfig } from "vue-router";

export const bootstrapRoute: RouteConfig[] = [
    {
        component: () => import("@/views/Bootstrap/BootstrapView.vue"),
        meta: {
            redirectTo: null,
        },
        path: '/',
    },
]
